import React from 'react';
import { bool, shape, string } from 'prop-types';

const InProgressColor = ({
  className = '',
  notUseClass = false,
  style = { color: '#9A6412' },
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M7.00033 1.16699C3.78033 1.16699 1.16699 3.78033 1.16699 7.00033C1.16699 10.2203 3.78033 12.8337 7.00033 12.8337C10.2203 12.8337 12.8337 10.2203 12.8337 7.00033C12.8337 3.78033 10.2203 1.16699 7.00033 1.16699ZM9.47366 4.52699C8.79116 3.84449 7.89866 3.50033 7.00033 3.50033V7.00033L4.52699 9.47366C5.89199 10.8387 8.10866 10.8387 9.47949 9.47366C10.8445 8.10866 10.8445 5.89199 9.47366 4.52699ZM2.33366 7.00033C2.33366 9.57866 4.42199 11.667 7.00033 11.667C9.57866 11.667 11.667 9.57866 11.667 7.00033C11.667 4.42199 9.57866 2.33366 7.00033 2.33366C4.42199 2.33366 2.33366 4.42199 2.33366 7.00033Z" fill="currentColor" />
  </svg>
);

InProgressColor.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default InProgressColor;
